export default "__VITE_ASSET__Dc1c6_hH__"